export default __webpack_public_path__ + "static/char-20-anr-b4a113a0b5f02d9125ad85beffd90032.webp";